"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zListPredefinedItemsQuery = exports.zUpdatePredefinedItemRequest = exports.zCreatePredefinedItemRequest = exports.zPredefinedItemData = exports.zPredefinedItemType = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
const money_js_1 = require("./money.js");
/**
 * This app's contracts only accept part/labor/sublet — the DB's own
 * `type` check additionally allows product/package/service for a planned
 * non-auto-repair fork (see the schema file's doc comment), but nothing
 * in this codebase ever writes those.
 */
exports.zPredefinedItemType = zod_1.z.enum(["part", "labor", "sublet"]);
// One shared shape covering every type this app writes, rather than a
// zod discriminated union keyed on `type` — nestjs-zod's createZodDto
// can't extend a discriminated union's inferred type (it resolves to a
// bare union, not a single object type with known members). `partNumber`
// only means something for `type: "part"` and `vendorName` only for
// `type: "sublet"`; each Add-line modal (part/labor/sublet) only shows
// the fields relevant to its own type, mirroring
// AddPartLineModal/AddLaborLineModal/AddSubletLineModal exactly.
exports.zPredefinedItemData = zod_1.z.object({
    description: zod_1.z.string().trim().min(1),
    partNumber: zod_1.z.string().trim().min(1).optional(),
    vendorName: zod_1.z.string().trim().min(1).optional(),
    price: money_js_1.zMoney.optional(),
    // Present (true) only when the item is tax exempt — picking it on a work
    // order pre-checks that line's "Tax exempt" box. Only offered while the
    // shop charges tax on this item's type.
    taxExempt: zod_1.z.literal(true).optional(),
    // Present (true) only when the item should NOT be charged shop supplies — picking it pre-unchecks
    // that line's "Include in shop supplies" box.
    noShopSupplies: zod_1.z.literal(true).optional(),
    // A state vehicle-inspection fee: implies tax exempt + no shop supplies, and the line gets
    // inspection details (result / VIR # / inspector) and shows on the Inspections page.
    stateInspection: zod_1.z.literal(true).optional(),
});
exports.zCreatePredefinedItemRequest = zod_1.z.object({
    type: exports.zPredefinedItemType,
    data: exports.zPredefinedItemData,
});
// `type` is immutable after creation — editing a wrong-type item means
// deleting and re-adding it.
exports.zUpdatePredefinedItemRequest = zod_1.z.object({
    data: exports.zPredefinedItemData.optional(),
    isActive: zod_1.z.boolean().optional(),
});
exports.zListPredefinedItemsQuery = zod_1.z.object({
    type: exports.zPredefinedItemType.optional(),
    search: zod_1.z.string().trim().min(1).optional(),
    includeInactive: query_params_js_1.zBooleanQueryParam.default(false),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=predefined-items.js.map